export default [
  {
    label: "Lit Guides",
    value: "Lit Guide"
  },
  {
    label: "Poetry Guides",
    value: "Poetry Guide"
  },
  {
    label: "Shakescleare",
    value: "Shakescleare"
  },
  {
    label: "Lit Terms",
    value: "Lit Term"
  }
];
